module.exports = __webpack_public_path__ + "img/0Q3A7086_L_BlackMatted_MockedUp.0b400bc9.jpg";